import { instance } from "apis/interceptor";
import { TNoShowDetailInfo } from "../../pages/meeting/NoshowPolicyManagement/NoshowReservationDetail/types";
import { TNoShowListItem, TSortType } from "pages/meeting/NoshowPolicyManagement/NoshowReservationManagementTab/types";

type NoShowListResponse = {
  totalSearchNumber: number;
  totalPageNumber: number;
  nowPageNumber: number;
  noshowList: TNoShowListItem[];
};

type ResponseType<T> = {
  success: boolean;
  message?: string;
  data?: T;
};

//* INFO: 노쇼 예약 목록 조회
export const getNoshowList = async (
  startDate: Date,
  endDate: Date,
  isRepeatRsv: boolean,
  sortType: TSortType,
  nowPageNumber: number
): Promise<ResponseType<NoShowListResponse>> => {
  try {
    const res = await instance.post("/meetings/no-show/list", {
      nowPageNumber: nowPageNumber,
      sortedBy: sortType,
      viewStartDate: startDate,
      viewEndDate: endDate,
      recurrenceOnly: isRepeatRsv,
    });
    return { success: true, data: res.data };
  } catch (error: any) {
    if (error.response?.status === 403) {
      return { success: false, message: "노쇼 예약 관리 페이지의 권한이 없습니다." };
    } else return { success: false, message: "노쇼 예약 목록 조회를 실패하였습니다." };
  }
};

//* INFO: 노쇼 예약 상세 정보 조회
export const getNoshowDetailInfo = async (
  id: string,
  startDate: Date,
  endDate: Date
): Promise<ResponseType<TNoShowDetailInfo>> => {
  try {
    const res = await instance.post("/meetings/no-show/detail", {
      instanceId: id,
      viewStartDate: startDate,
      viewEndDate: endDate,
    });

    return { success: true, data: res.data };
  } catch (error: any) {
    if (error.response?.status === 403) {
      return { success: false, message: "노쇼 예약 관리 페이지의 권한이 없습니다." };
    } else return { success: false, message: "노쇼 예약 정보를 불러오는데 실패하였습니다." };
  }
};

//* INFO: 노쇼 반복 예약 취소
export const cancelNoshow = async (instanceId: string): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.patch("/meetings/no-show/cancel", {
      instanceId: instanceId,
    });
    return { success: true };
  } catch (error: any) {
    return { success: false };
  }
};

//* INFO: 노쇼 예약 취소 요청
export const cancelNoshowRequest = async (instanceId: string) => {
  try {
    const res = await instance.post("/meetings/no-show/cancel-request", {
      instanceId: instanceId,
    });

    return { success: true };
  } catch (error: any) {
    return { success: false };
  }
};

//* INFO: 노쇼 예약 취소 (요청 메시지 내)
export const cancelNoshowInMessage = async (id: string, memberPublicId: string) => {
  try {
    const res = await instance.patch("/meetings/no-show/cancel/by-request", {
      id: id,
      memberPublicId: memberPublicId,
      page: "REQ_EMAIL",
    });
    return { success: true };
  } catch (error: any) {
    return { success: false };
  }
};

//* INFO: 노쇼 예약 상세 정보 조회 (요청 메시지 내)
export const getNoshowDetailInfoByRequestEmail = async (id: string) => {
  try {
    const res = await instance.post("/meetings/no-show/detail/by-id", {
      id: id,
    });
    return { success: true, data: res.data };
  } catch (error: any) {
    return { success: false };
  }
};
